module.exports = __webpack_public_path__ + "img/Q20-2-768x480.8d5febee.png";